import type { HeadlinePinPosition } from '../../types/campaign';

// Pinned Headlines spec §2.3: small read-only badge that surfaces the
// pin position (P1 / P2 / P3) inline next to a headline. Renders
// nothing when pinPosition is null so callers can pass the field
// straight through without gating.
//
// Visual: muted slate pill — visible but unobtrusive, paired with the
// HeadlinePinButton's filled style on the editor side. Same wording
// the buyer pastes into Google Ads ("Position 1" → "P1").

export function PinBadge({ pinPosition }: { pinPosition: HeadlinePinPosition }) {
  if (pinPosition === null) return null;
  return (
    <span
      className="inline-flex items-center text-[10px] font-semibold leading-none bg-slate-200 text-slate-700 px-1.5 py-0.5 rounded"
      title={`Pinned to position ${pinPosition}`}
      aria-label={`Pinned to position ${pinPosition}`}
    >
      P{pinPosition}
    </span>
  );
}
